import React from "react";
import { useRazorpay } from "../../../../context/RazorpayContext";

const AddonPreviewModal = ({ accountType, setShowPage, onCancelPaymentNavigationUrl }) => {

  const {
    addonInvoicePreviewData,
    handleAddOnSellerAccount,
    onCloseAddOnInvoicePreview
  } = useRazorpay();

  if (!addonInvoicePreviewData?.isOpenModal) return null;

  // const packangeName = addonInvoicePreviewData?.previewData?.to_package;
  const planPrice = addonInvoicePreviewData?.previewData?.amount;

  const handleSubmitArgument = () => {
    if (accountType === 'amazonAds') {
      return { type: 'amazonAds', action: setShowPage }
    }
    return null
  }
  

  return (
    <>
      <div
        className="modal d-flex align-items-center justify-content-center"
        style={{
          display: "flex",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1052,

        }}
      >
        <div
          className="modal-dialog animate__animated animate__fadeInDown"
          style={{
            maxWidth: "600px",
            width: "100%",
            margin: "0 auto",
          }}
        >
          <div
            className="modal-content border-0 rounded-4 shadow-lg"
            style={{
              background: "linear-gradient(145deg, #ffffff, #f9fafb)",
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <div className="modal-header border-0">
              <h4
                className="modal-title fw-bold text-dark"
                style={{ fontSize: "1.2rem" }}
              >
                <i className="bi bi-credit-card"></i>{" "}
                Billing Summary
              </h4>
              {accountType === 'marketPlaceAccount' &&
                <div className="modal-close-btn">
                  <button type="button" className="btn-close" onClick={onCloseAddOnInvoicePreview}></button>
                </div>
              }
            </div>

            {/* Body */}
            <div className="modal-body package-modal p-3 p-md-4">
              <div className="px-3 rounded-4 shadow-sm bg-white">

                {/* Price */}
                <div className="bg-light rounded p-3 mb-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="text-muted small fw-medium">
                      {/* <i className="bi bi-tag text-success me-2"></i> */}
                      Billing Cycle
                    </span>
                    <span className="fw-semibold text-dark">
                      {planPrice} {addonInvoicePreviewData?.previewData?.billing_cycle || ""}
                    </span>
                  </div>
                </div>

                {/* Billing Dates */}



                <div className="overflow-hidden mb-4">

                  <table className="table mb-0 table-borderless">
                    <thead className="table-light">
                      <tr>
                        <th className="text-start px-3 py-2 small fw-semibold text-secondary">
                          Account Name
                        </th>
                        <th className="text-end px-3 py-2 small fw-semibold text-secondary">
                          Monthly
                        </th>
                        <th className="text-end px-3 py-2 small fw-semibold text-secondary">
                          This Month
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {addonInvoicePreviewData?.previewData?.accounts?.map((item, index) => (
                        <tr key={index} className="table-hover">
                          <td className="px-3 py-2 small text-dark">{item.name}</td>
                          <td className="px-3 py-2 small text-end fw-medium text-dark">{item.amount}</td>
                          <td className="px-3 py-2 small text-end fw-medium text-dark">{item.prorated_amount}</td>
                        </tr>
                      ))}
                      {/* Total Row */}
                      <tr className="table-hover border-top">
                        <td className="px-3 py-2 small text-dark fw-semibold">
                          Total Amount
                        </td>
                        <td className="px-3 py-2 small text-end fw-bold text-dark">
                          {addonInvoicePreviewData?.previewData?.total_amount}
                        </td>
                        <td className="px-3 py-1 small text-end fw-bold text-dark">
                          {addonInvoicePreviewData?.previewData?.prorated_amount}
                        </td>
                      </tr>
                    </tbody>
                    
                  </table>
                </div>

              </div>
            </div>

            {/* Footer */}
            <div
              className="border-0 d-flex flex-column flex-sm-row justify-content-between px-3 px-md-4 pb-4"
              style={{ gap: "10px" }}
            >
              <div className="col-md-6 col-12">
                <button className="btn btn-light w-100 w-sm-auto px-4 py-2 rounded-3 border shadow-sm" disabled={addonInvoicePreviewData?.isLoading} onClick={(e) => onCloseAddOnInvoicePreview(e, onCancelPaymentNavigationUrl)}>
                  Cancel
                </button>
              </div>
              <div className="col-md-6 col-12">
                <button
                  className="btn plan-detail-card-btn w-100 w-sm-auto px-4 py-2 fw-semibold rounded-3 shadow"
                  onClick={(e) => handleAddOnSellerAccount(e, addonInvoicePreviewData?.previewData?.accounts || addonInvoicePreviewData?.previewData?.subscribable_id || addonInvoicePreviewData?.previewData?.marketplace_account_id, handleSubmitArgument())}
                  disabled={addonInvoicePreviewData?.isLoading}
                >
                  {addonInvoicePreviewData?.isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Loading...
                    </>
                  ) : <> Continue to Payment </>
                  }
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddonPreviewModal;